import React, { useMemo } from 'react';

import {
	useCloudId,
	useFiltersDiscoverability2Enabled,
} from '../../../../../controllers/store/bootstrap';

import SiteSelect, { type SiteOption } from './index';

// TODO(QS-9518): Replace this hard-coded stub with real site + org loading. The primary/current
// site (the real signed-in `cloudId`) is always first; the rest are placeholders.
const useSiteSelector = (primaryCloudId: string): { sites: SiteOption[]; orgName: string } =>
	useMemo(
		() => ({
			orgName: 'Atlassian',
			sites: [
				{ cloudId: primaryCloudId, name: 'Current site' },
				{ cloudId: 'mock-site-b', name: 'Acme Sandbox' },
				{ cloudId: 'mock-site-c', name: 'Acme EU' },
				{ cloudId: 'mock-site-d', name: 'Acme Dev' },
			],
		}),
		[primaryCloudId],
	);

// Selection is not persisted yet — toggling is a no-op until it is wired to the URL.
const noOp = () => {
	/* no-op until site selection is persisted to the URL */
};

/**
 * Connected wrapper for the multi-site {@link SiteSelect}. Only rendered in Full Page Search for now.
 */
const SiteSelectFilter = ({
	isFilterInDropdown,
}: {
	isFilterInDropdown?: boolean;
}): React.JSX.Element => {
	const [cloudId] = useCloudId();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();

	const primarySiteId = cloudId ?? '';
	const { sites, orgName } = useSiteSelector(primarySiteId);

	return (
		<SiteSelect
			sites={sites}
			selectedSiteIds={primarySiteId ? [primarySiteId] : []}
			primarySiteId={primarySiteId}
			orgName={orgName}
			onSelectSite={noOp}
			onUnselectSite={noOp}
			isFilterInDropdown={isFilterInDropdown}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
		/>
	);
};

export default SiteSelectFilter;
